import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-fee31146"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "shadow sm:rounded-t-md sm:overflow-hidden" };
const _hoisted_2 = { class: "bg-white py-6 px-4 space-y-6 sm:p-6" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "\n            Job Details\n          ")
], -1));
const _hoisted_4 = { class: "grid grid-cols-3 gap-6" };
const _hoisted_5 = { class: "col-span-6" };
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "jobTitle",
    class: "block text-sm font-medium text-gray-700"
}, "What is the job title of the role? *", -1));
const _hoisted_7 = ["value", "disabled"];
const _hoisted_8 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_9 = { class: "grid grid-cols-3 gap-6 sm:border-t sm:border-gray-200 sm:pt-5 mt-4" };
const _hoisted_10 = { class: "col-span-6" };
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "numberOfPositions",
    class: "block text-sm font-medium text-gray-700"
}, "How many positions are you recruiting for? *", -1));
const _hoisted_12 = ["value", "disabled"];
const _hoisted_13 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_14 = { class: "grid grid-cols-3 gap-6 sm:border-t sm:border-gray-200 sm:pt-5 mt-4" };
const _hoisted_15 = { class: "col-span-6" };
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "roleLocationSite",
    class: "block text-sm font-medium text-gray-700"
}, "Role Location (Site): *", -1));
const _hoisted_17 = ["value", "disabled"];
const _hoisted_18 = ["value"];
const _hoisted_19 = ["value"];
const _hoisted_20 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "mt-1 text-sm text-red-500" }, [
    /*#__PURE__*/ _createElementVNode("b", null, "\n                  *Please note this is still required even if the employee is a\n                  Mobile Worker.\n                ")
], -1));
const _hoisted_22 = { class: "grid grid-cols-3 gap-6 sm:border-t sm:border-gray-200 sm:pt-5 mt-4" };
const _hoisted_23 = { class: "col-span-6" };
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "roleLocationPostcode",
    class: "block text-sm font-medium text-gray-700"
}, "Role Location (Postcode):", -1));
const _hoisted_25 = ["value"];
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "mt-1 text-sm text-red-500" }, [
    /*#__PURE__*/ _createElementVNode("b", null, "\n                  *Please note this is still required even if the employee is a\n                  Mobile Worker.\n                ")
], -1));
const _hoisted_27 = { class: "grid grid-cols-3 gap-6 sm:border-t sm:border-gray-200 sm:pt-5 mt-4" };
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("legend", { class: "text-base font-medium text-gray-900" }, "\n                What is the employment contract for this role? *\n              ", -1));
const _hoisted_29 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_30 = { class: "mt-4 space-y-4" };
const _hoisted_31 = { class: "flex items-start" };
const _hoisted_32 = { class: "h-5 flex items-center" };
const _hoisted_33 = ["checked", "disabled"];
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "employmentContract",
        class: "font-medium text-gray-700"
    }, "Apprentice")
], -1));
const _hoisted_35 = { class: "flex items-start" };
const _hoisted_36 = { class: "h-5 flex items-center" };
const _hoisted_37 = ["disabled", "checked"];
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "employmentContract",
        class: "font-medium text-gray-700"
    }, "Fixed Term")
], -1));
const _hoisted_39 = { class: "flex items-start" };
const _hoisted_40 = { class: "h-5 flex items-center" };
const _hoisted_41 = ["checked", "disabled"];
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "employmentContract",
        class: "font-medium text-gray-700"
    }, "Graduate")
], -1));
const _hoisted_43 = { class: "flex items-start" };
const _hoisted_44 = { class: "h-5 flex items-center" };
const _hoisted_45 = ["disabled", "checked"];
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "employmentContract",
        class: "font-medium text-gray-700"
    }, "Permanent")
], -1));
const _hoisted_47 = { class: "flex items-start" };
const _hoisted_48 = { class: "h-5 flex items-center" };
const _hoisted_49 = ["disabled", "checked"];
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "employmentContract",
        class: "font-medium text-gray-700"
    }, "Secondment")
], -1));
const _hoisted_51 = { class: "flex items-start" };
const _hoisted_52 = { class: "h-5 flex items-center" };
const _hoisted_53 = ["disabled", "checked"];
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "employmentContract",
        class: "font-medium text-gray-700"
    }, "Zero Hours")
], -1));
const _hoisted_55 = { class: "grid grid-cols-3 gap-6 sm:border-t sm:border-gray-200 sm:pt-5 mt-4" };
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("legend", { class: "text-base font-medium text-gray-900" }, "\n                As this is a secondment please specify if an allowance or the\n                full salary should be shown *\n              ", -1));
const _hoisted_57 = { class: "mt-4 space-y-4" };
const _hoisted_58 = { class: "flex items-start" };
const _hoisted_59 = { class: "h-5 flex items-center" };
const _hoisted_60 = ["checked"];
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "secondment",
        class: "font-medium text-gray-700"
    }, "Allowance")
], -1));
const _hoisted_62 = { class: "mt-4 space-y-4" };
const _hoisted_63 = { class: "flex items-start" };
const _hoisted_64 = { class: "h-5 flex items-center" };
const _hoisted_65 = ["checked"];
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "secondment",
        class: "font-medium text-gray-700"
    }, "Full Salary")
], -1));
const _hoisted_67 = { class: "grid grid-cols-3 gap-6 sm:border-t sm:border-gray-200 sm:pt-5 mt-4" };
const _hoisted_68 = { class: "col-span-6" };
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "duration",
    class: "block text-sm font-medium text-gray-700"
}, "What is the duration of the employment contract? *", -1));
const _hoisted_70 = ["value"];
const _hoisted_71 = { class: "text-sm text-red-700" };
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("a", {
    href: "https://equans.sharepoint.com/:w:/r/sites/ukbuems/_layouts/15/Doc.aspx?sourcedoc=%7B82D33E70-6205-41EF-805D-642F09CB3854%7D&file=EQUANS%20Apprentice%20Details%20Form.docx&action=default&mobileredirect=true",
    target: "_blank",
    class: "text-blue-600 hover:underline"
}, "here", -1));
const _hoisted_73 = { class: "text-sm text-red-700" };
const _hoisted_74 = {
    key: 0,
    class: "px-4 py-3 bg-gray-50 text-right sm:px-6"
};
const _hoisted_75 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("form", null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _hoisted_3,
                _createTextVNode(),
                _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                            _hoisted_6,
                            _createTextVNode(),
                            _createElementVNode("input", {
                                id: "input-job-title",
                                value: _ctx.formData.jobTitle,
                                type: "text",
                                name: "jobTitle",
                                autocomplete: "jobTitle",
                                class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md", {
                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                        'error-border': _ctx.v$.formData.jobTitle.$error,
                                        'border-red-500': _ctx.v$.formData.jobTitle.$error,
                                    }]),
                                disabled: _ctx.showApprovalSteps,
                                onInput: _cache[0] || (_cache[0] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleInputChange && _ctx.handleInputChange(...args))),
                                onBlur: _cache[1] || (_cache[1] = ($event) => (_ctx.v$.formData.jobTitle.$touch()))
                            }, null, 42, _hoisted_7),
                            _createTextVNode(),
                            (_ctx.v$.formData.jobTitle.$errors.length)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_8, "\n                * " + _toDisplayString(_ctx.v$.formData.jobTitle.$errors[0].$message), 1))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                            _hoisted_11,
                            _createTextVNode(),
                            _createElementVNode("input", {
                                id: "input-number-of-positions",
                                value: _ctx.formData.numberOfPositions,
                                type: "number",
                                min: "0",
                                name: "numberOfPositions",
                                autocomplete: "numberOfPositions",
                                class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md", {
                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                        'error-border': _ctx.v$.formData.numberOfPositions.$error,
                                        'border-red-500': _ctx.v$.formData.numberOfPositions.$error,
                                    }]),
                                disabled: _ctx.showApprovalSteps,
                                onInput: _cache[2] || (_cache[2] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleInputChange && _ctx.handleInputChange(...args))),
                                onBlur: _cache[3] || (_cache[3] = ($event) => (_ctx.v$.formData.numberOfPositions.$touch()))
                            }, null, 42, _hoisted_12),
                            _createTextVNode(),
                            (_ctx.v$.formData.numberOfPositions.$errors.length)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_13, "\n                * " + _toDisplayString(_ctx.v$.formData.numberOfPositions.$errors[0].$message), 1))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                            _hoisted_16,
                            _createTextVNode(),
                            _createElementVNode("select", {
                                id: "input-role-location-site",
                                value: _ctx.formData.roleLocationSite,
                                name: "roleLocationSite",
                                autocomplete: "roleLocationSite",
                                class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md", {
                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                        'error-border': _ctx.v$.formData.roleLocationSite.$error,
                                        'border-red-500': _ctx.v$.formData.roleLocationSite.$error,
                                    }]),
                                disabled: _ctx.showApprovalSteps,
                                onChange: _cache[4] || (_cache[4] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleInputChange && _ctx.handleInputChange(...args))),
                                onBlur: _cache[5] || (_cache[5] = ($event) => (_ctx.v$.formData.roleLocationSite.$touch()))
                            }, [
                                (_ctx.showApprovalSteps)
                                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.configData.LOCATIONS, (location) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                            key: location.LOCATIONCODE,
                                            value: `${location.OBJECTNAME} - ${location.LOCATIONCODE}`
                                        }, _toDisplayString(location.DISPLAYNAME), 9, _hoisted_18));
                                    }), 128))
                                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.activeLocations, (location) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                            key: location.LOCATIONCODE,
                                            value: `${location.OBJECTNAME} - ${location.LOCATIONCODE}`
                                        }, _toDisplayString(location.DISPLAYNAME), 9, _hoisted_19));
                                    }), 128))
                            ], 42, _hoisted_17),
                            _createTextVNode(),
                            (_ctx.v$.formData.roleLocationSite.$errors.length)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_20, "\n                * " + _toDisplayString(_ctx.v$.formData.roleLocationSite.$errors[0].$message), 1))
                                : _createCommentVNode("", true),
                            _createTextVNode(),
                            _hoisted_21
                        ])
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                            _hoisted_24,
                            _createTextVNode(),
                            _createElementVNode("input", {
                                id: "input-role-location-postcode",
                                disabled: "",
                                value: _ctx.formData.roleLocationPostcode,
                                name: "roleLocationPostcode",
                                autocomplete: "roleLocationPostcode",
                                class: _normalizeClass(["mt-1 p-2 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-600", {
                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                    }])
                            }, null, 10, _hoisted_25),
                            _createTextVNode(),
                            _hoisted_26
                        ])
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("fieldset", null, [
                            _hoisted_28,
                            _createTextVNode(),
                            (_ctx.v$.formData.employmentContract.$errors.length)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_29, "\n                * " + _toDisplayString(_ctx.v$.formData.employmentContract.$errors[0].$message), 1))
                                : _createCommentVNode("", true),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_30, [
                                _createElementVNode("div", _hoisted_31, [
                                    _createElementVNode("div", _hoisted_32, [
                                        _createElementVNode("input", {
                                            id: "radio-employment-contract-apprentice",
                                            name: "employmentContract",
                                            type: "radio",
                                            value: "Apprentice",
                                            class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded", {
                                                    'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                }]),
                                            checked: _ctx.formData.employmentContract === 'Apprentice',
                                            disabled: _ctx.showApprovalSteps,
                                            onChange: _cache[6] || (_cache[6] =
                                                //@ts-ignore
                                                (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                            onBlur: _cache[7] || (_cache[7] = ($event) => (_ctx.v$.formData.employmentContract.$touch()))
                                        }, null, 42, _hoisted_33)
                                    ]),
                                    _createTextVNode(),
                                    _hoisted_34
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_35, [
                                    _createElementVNode("div", _hoisted_36, [
                                        _createElementVNode("input", {
                                            id: "radio-employment-contract-fixed-term",
                                            name: "employmentContract",
                                            type: "radio",
                                            value: "Fixed Term",
                                            class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded", {
                                                    'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                }]),
                                            disabled: _ctx.showApprovalSteps,
                                            checked: _ctx.formData.employmentContract === 'Fixed Term',
                                            onChange: _cache[8] || (_cache[8] =
                                                //@ts-ignore
                                                (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                            onBlur: _cache[9] || (_cache[9] = ($event) => (_ctx.v$.formData.employmentContract.$touch()))
                                        }, null, 42, _hoisted_37)
                                    ]),
                                    _createTextVNode(),
                                    _hoisted_38
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_39, [
                                    _createElementVNode("div", _hoisted_40, [
                                        _createElementVNode("input", {
                                            id: "radio-employment-contract-graduate",
                                            name: "employmentContract",
                                            type: "radio",
                                            value: "Graduate",
                                            class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded", {
                                                    'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                }]),
                                            checked: _ctx.formData.employmentContract === 'Graduate',
                                            disabled: _ctx.showApprovalSteps,
                                            onChange: _cache[10] || (_cache[10] =
                                                //@ts-ignore
                                                (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                            onBlur: _cache[11] || (_cache[11] = ($event) => (_ctx.v$.formData.employmentContract.$touch()))
                                        }, null, 42, _hoisted_41)
                                    ]),
                                    _createTextVNode(),
                                    _hoisted_42
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_43, [
                                    _createElementVNode("div", _hoisted_44, [
                                        _createElementVNode("input", {
                                            id: "radio-employment-contract-permanent",
                                            name: "employmentContract",
                                            type: "radio",
                                            value: "Permanent",
                                            class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded", {
                                                    'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                }]),
                                            disabled: _ctx.showApprovalSteps,
                                            checked: _ctx.formData.employmentContract === 'Permanent',
                                            onChange: _cache[12] || (_cache[12] =
                                                //@ts-ignore
                                                (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                            onBlur: _cache[13] || (_cache[13] = ($event) => (_ctx.v$.formData.employmentContract.$touch()))
                                        }, null, 42, _hoisted_45)
                                    ]),
                                    _createTextVNode(),
                                    _hoisted_46
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_47, [
                                    _createElementVNode("div", _hoisted_48, [
                                        _createElementVNode("input", {
                                            id: "radio-employment-contract-secondment",
                                            name: "employmentContract",
                                            type: "radio",
                                            value: "Secondment",
                                            class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded", {
                                                    'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                }]),
                                            disabled: _ctx.showApprovalSteps,
                                            checked: _ctx.formData.employmentContract === 'Secondment',
                                            onChange: _cache[14] || (_cache[14] =
                                                //@ts-ignore
                                                (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                            onBlur: _cache[15] || (_cache[15] = ($event) => (_ctx.v$.formData.employmentContract.$touch()))
                                        }, null, 42, _hoisted_49)
                                    ]),
                                    _createTextVNode(),
                                    _hoisted_50
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_51, [
                                    _createElementVNode("div", _hoisted_52, [
                                        _createElementVNode("input", {
                                            id: "radio-employment-contract-zero-hours",
                                            name: "employmentContract",
                                            type: "radio",
                                            value: "Zero Hours",
                                            class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded", {
                                                    'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                }]),
                                            disabled: _ctx.showApprovalSteps,
                                            checked: _ctx.formData.employmentContract === 'Zero Hours',
                                            onChange: _cache[16] || (_cache[16] =
                                                //@ts-ignore
                                                (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                            onBlur: _cache[17] || (_cache[17] = ($event) => (_ctx.v$.formData.employmentContract.$touch()))
                                        }, null, 42, _hoisted_53)
                                    ]),
                                    _createTextVNode(),
                                    _hoisted_54
                                ])
                            ])
                        ])
                    ]),
                    _createTextVNode(),
                    _withDirectives(_createElementVNode("div", _hoisted_55, [
                        _createElementVNode("fieldset", null, [
                            _hoisted_56,
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_57, [
                                _createElementVNode("div", _hoisted_58, [
                                    _createElementVNode("div", _hoisted_59, [
                                        _createElementVNode("input", {
                                            id: "radio-secondment",
                                            name: "secondment",
                                            type: "radio",
                                            value: "Allowance",
                                            class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded",
                                            checked: _ctx.formData.secondment === 'Allowance',
                                            onChange: _cache[18] || (_cache[18] =
                                                //@ts-ignore
                                                (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args)))
                                        }, null, 40, _hoisted_60)
                                    ]),
                                    _createTextVNode(),
                                    _hoisted_61
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_62, [
                                _createElementVNode("div", _hoisted_63, [
                                    _createElementVNode("div", _hoisted_64, [
                                        _createElementVNode("input", {
                                            id: "radio-secondment",
                                            name: "secondment",
                                            type: "radio",
                                            value: "Full Salary",
                                            class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded",
                                            checked: _ctx.formData.secondment === 'Full Salary',
                                            onChange: _cache[19] || (_cache[19] =
                                                //@ts-ignore
                                                (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args)))
                                        }, null, 40, _hoisted_65)
                                    ]),
                                    _createTextVNode(),
                                    _hoisted_66
                                ])
                            ])
                        ])
                    ], 512), [
                        [_vShow, _ctx.formData.employmentContract === 'Secondment']
                    ]),
                    _createTextVNode(),
                    _withDirectives(_createElementVNode("div", _hoisted_67, [
                        _createElementVNode("div", _hoisted_68, [
                            _hoisted_69,
                            _createTextVNode(),
                            _createElementVNode("input", {
                                id: "input-duration",
                                value: _ctx.formData.duration,
                                type: "number",
                                min: "0",
                                name: "duration",
                                autocomplete: "duration",
                                class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md", {
                                        'error-border': _ctx.v$.formData.duration.$error,
                                        'border-red-500': _ctx.v$.formData.duration.$error,
                                    }]),
                                onInput: _cache[20] || (_cache[20] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleInputChange && _ctx.handleInputChange(...args)))
                            }, null, 42, _hoisted_70),
                            _createTextVNode(),
                            _withDirectives(_createElementVNode("p", _hoisted_71, [
                                _createTextVNode("\n                For Apprentice, please complete and attach the Apprentice\n                Details Form, a copy of the form is avaliable\n                "),
                                _hoisted_72
                            ], 512), [
                                [_vShow, _ctx.formData.employmentContract === 'Apprentice']
                            ]),
                            _createTextVNode(),
                            _withDirectives(_createElementVNode("p", _hoisted_73, "\n                Please enter a numerical value in Months\n              ", 512), [
                                [_vShow, _ctx.formShow]
                            ])
                        ])
                    ], 512), [
                        [_vShow, _ctx.formShow]
                    ])
                ])
            ])
        ]),
        _createTextVNode(),
        (!_ctx.showApprovalSteps)
            ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                _createElementVNode("button", {
                    class: "mr-2 bg-green-500 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500",
                    onClick: _cache[21] || (_cache[21] = _withModifiers(
                    //@ts-ignore
                    (...args) => (_ctx.handleResetForm && _ctx.handleResetForm(...args)), ["prevent"]))
                }, "\n        Reset Form\n      "),
                _createTextVNode(),
                _createElementVNode("button", {
                    disabled: _ctx.v$.$invalid,
                    type: "submit",
                    class: "bg-green-500 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400",
                    onClick: _cache[22] || (_cache[22] =
                        //@ts-ignore
                        (...args) => (_ctx.handleSave && _ctx.handleSave(...args)))
                }, "\n        Next\n      ", 8, _hoisted_75)
            ]))
            : _createCommentVNode("", true)
    ]));
}
